import { render, staticRenderFns } from "./plansContentChild.vue?vue&type=template&id=59673452&scoped=true"
import script from "./plansContentChild.vue?vue&type=script&lang=js"
export * from "./plansContentChild.vue?vue&type=script&lang=js"
import style0 from "./plansContentChild.vue?vue&type=style&index=0&id=59673452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59673452",
  null
  
)

export default component.exports